<template>
  <div class="form-container">
    <div class="form-header">
      <h1>Admin Debug Tools</h1>
    </div>

    <form class="form">
      <div class="form-section">
        <h3>File Media Info</h3>
        <div class="form-group full-width">
          <label for="file_media_info">Video Metadata Inspector</label>
          <FileMediaInfo 
            class="form-control"
            id="file_media_info"
          />
        </div>
      </div>

      <div class="form-section">
        <h3>File Upload</h3>
        <div class="form-group full-width">
          <label for="file_upload">Upload to test folder</label>
          <FileUpload 
            :maxFileSize="50 * 1024 * 1024 * 1024"
            folder="test-uploads"
            class="form-control"
            id="file_upload"
            @success="handleUploadSuccess"
            @error="handleUploadError"
          />
          <div v-if="uploadedFileUrl" class="upload-result">
            <label>Uploaded File URL:</label>
            <a :href="uploadedFileUrl" target="_blank" class="file-url">{{ uploadedFileUrl }}</a>
          </div>
          <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import FileMediaInfo from '@/components/FileMediaInfo.vue';
import FileUpload from '@/components/FileUpload.vue';

const uploadedFileUrl = ref('');
const errorMessage = ref('');

const handleUploadSuccess = (fileInfo) => {
  uploadedFileUrl.value = fileInfo.url;
  errorMessage.value = '';
};

const handleUploadError = (error) => {
  errorMessage.value = error;
  uploadedFileUrl.value = '';
};
</script>

<style scoped>
@import '@/styles/shared-form.css';

.section-description {
  color: #64748b;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.upload-result {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.upload-result label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
}

.file-url {
  word-break: break-all;
  color: #3b82f6;
  text-decoration: none;
}

.file-url:hover {
  text-decoration: underline;
}

.error-message {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #fee2e2;
  color: #b91c1c;
  border-radius: 4px;
}
</style>
